<div class="container px-5 pb-5 text-center">
  <h2 class="pb-3 pr-4 mb-3 d-inline-block border-bottom">Alle bordvers</h2>
  <a *ngFor="let song of GetAllSongs()" [routerLink]="['/vers', song.handle]" class="mb-2">{{song.title}}</a>
</div>